import { useEffect, useRef, useState } from "react";
import { useInView, animate, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";

export const STATS = [
  [10, "Years of Experience"], [15, "Subject Experts"], [15, "Senior Technicians"], [15, "Junior Technicians"],
];

const CountUp = ({ to }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const reduce = useReducedMotion();
  const [val, setVal] = useState(to);
  useEffect(() => {
    if (!inView || reduce) return undefined;
    const c = animate(0, to, { duration: 1.6, ease: [0.2, 0.7, 0.2, 1], onUpdate: (v) => setVal(Math.round(v)) });
    return () => c.stop();
  }, [inView, reduce, to]);
  return <span ref={ref}>{val}</span>;
};

export const StatsBand = ({ dark = false }) => (
  <div data-testid="stats-band" className={`grid grid-cols-2 lg:grid-cols-4 border-y ${dark ? "border-white/10 text-white" : "border-[#102A43]/12 text-[#102A43]"}`}>
    {STATS.map(([n, label], i) => (
      <Reveal key={label} delay={i * 0.08} className={`relative px-5 sm:px-8 py-10 md:py-14 ${i % 2 ? "" : "border-r"} ${i < 2 ? "border-b lg:border-b-0" : ""} lg:border-r ${dark ? "border-white/10" : "border-[#102A43]/12"} last:border-r-0`}>
        <span className={`absolute left-5 sm:left-8 top-5 font-mono text-[11px] tracking-widest ${dark ? "text-[#9fb3c8]" : "text-[#526579]"}`}>0{i + 1} /</span>
        <p data-testid={`stat-value-${i}`} className="font-display text-5xl md:text-7xl font-extrabold tracking-tight">
          <CountUp to={n} /><span className="text-[#D8B66A]">+</span>
        </p>
        <p className={`mt-2 text-sm font-semibold uppercase tracking-[0.14em] ${dark ? "text-[#c3d0dd]" : "text-[#526579]"}`}>{label}</p>
      </Reveal>
    ))}
  </div>
);
